import { render } from "./NewLocationFormN.vue?vue&type=template&id=43719e36"
import script from "./NewLocationFormN.vue?vue&type=script&lang=js"
export * from "./NewLocationFormN.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__